import { useAdminAuthStore } from '@/store/admin/adminAuthStore';

export const isAdminLoggedIn = Boolean(
  useAdminAuthStore.getState().adminAccessToken,
);

export const adminSignOut = () => {
  useAdminAuthStore.getState().clear();
  window.location.href = '/admin';
};
